import Vue from 'vue'
import Router from 'vue-router'
import { saveTokenFromUrl } from '@/utils/auth'


const mineAddressPage = () => import(/* webpackChunkName: "Login" */ '../pages/h5/mine-address-page')
const shopAddressPage = () => import(/* webpackChunkName: "Login" */ '../pages/h5/shop-address-page')
const orderPage = () => import(/* webpackChunkName: "Login" */ '../pages/h5/order-page')
const orderRefundPage = () => import(/* webpackChunkName: "OrderRefund" */ '../pages/h5/order-refund-page')
const shopPage = () => import(/* webpackChunkName: "Login" */ '../pages/h5/shop-info-page')
const loading = () => import(/* webpackChunkName: "MyWallet" */  '../pages/h5/loading')









Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '選擇地址',
      meta: {
        title: '選擇地址'
      },
      component: mineAddressPage
    },
    {
      path: '/shop-address-page',
      name: '商家地址',
      meta: {
        title: '商家地址'
      },
      component: shopAddressPage
    },
    {
      path: '/order-page',
      name: '訂單詳情',
      meta: {
        title: '訂單詳情'
      },
      component: orderPage
    },
    {
      path: '/order-refund-page',
      name: '退款詳情',
      meta: {
        title: '退款詳情'
      },
      component: orderRefundPage
    },
    {
      path: '/shop-info-page',
      name: '商家詳情',
      meta: {
        title: '商家詳情'
      },
      component: shopPage
    },
    {
      path: '/loading',
      name: '商家詳情',
      meta: {
        title: '商家詳情'
      },
      component: loading
    },
  ]
})

// router.beforeEach((to, from, next) => {
//   let map = document.getElementById('googleMap')
//   if(to.path=='/loading'){
//     next()
//     return
//   }else{
//     if(map){
//       next()
//     }else{
//       let url = to.path+'?'
//       if(JSON.stringify(to.query)!=='{}'){
//         for(let key in to.query){
//           url+=key+'='+to.query[key]+'&'
//         }
//       }
//       window.localStorage.setItem('url',url.substr(0,url.length-1))
//       next({path:'/loading'})
//     }
//   }
// })


// 進入應用時，從路由(url)上取出 token 存到 sessionStorage（key = jb-authorization）；
// 路由上沒有 token 時不做任何處理，沿用既有邏輯
router.beforeEach((to, from, next) => {
  saveTokenFromUrl()
  next()
})

export default router
